import { render, staticRenderFns } from "./CreateEditModifierGroup.vue?vue&type=template&id=07c9b7f7"
import script from "./CreateEditModifierGroup.vue?vue&type=script&lang=js"
export * from "./CreateEditModifierGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports